import { FilterGroup } from '../Tools/FilterGroup';
import { ShowUnavailableFilter } from '../Filters/ShowUnavailableFilter';
import { ShowRSEFilter } from '../Filters/ShowRSEFilter';
import { ShowContentFactoryFilter } from '../Filters/ShowContentFactoryFilter';
import { ShowNewObjectsFilter } from '../Filters/ShowNewObjectsFilter';
import { IFilter } from '../Tools/IFilter';
import { FiltersController } from '../Tools/FiltersController';
import { FiltersWidget } from '../FiltersWidget';
declare var Savane: any;
declare var AssetManagerServices: any;
export class PinBoardsFilterWidget extends FilterGroup {
    constructor(container: string) {
        super();
        this.id = 'pinboards';
        this.name = 'Favoris';
        this.icon = 'fas fa-lg fa-heart';
        this.resource = 'allAssets';
        this.filtersFunction = 'updateFilters';
        this.container = container;
        this.filters = [
            new ShowUnavailableFilter(this),
            new ShowRSEFilter(this),
            new ShowContentFactoryFilter(this),
            new ShowNewObjectsFilter(this)
        ];
        this.controller = new FiltersController();

        this.filtersHtml = () => {
            let PinBoardsFilterWidgetHtml = '';
            let showHtml = '<div class="noPadding" style="display: flex;flex-direction: row; justify-content: space-around;" id="showFilters">';
            this.filters.forEach((filter: IFilter) => {
                if (filter.type.toLowerCase().search('show') !== -1
                    && filter.type.toLowerCase() !== 'showpriority') {
                    showHtml += `${filter.html()}`;
                } else {
                    PinBoardsFilterWidgetHtml += `${filter.html()}`;
                }
            });
            showHtml += '</div>';
            PinBoardsFilterWidgetHtml += showHtml;
            return PinBoardsFilterWidgetHtml;
        };
    }

    generateStringFilter() {
        var i: number;
        let stringFilters = super.generateStringFilter();
        let filters = FilterGroup.filters;

        if (filters.style !== null && filters.style.length > 0) {
            stringFilters += '&q.styles._id.in=';
            for (i = 0; i < filters.style.length; i++) {
                if (i > 0) {
                    stringFilters += ',';
                }
                stringFilters += filters.style[i]._id;
            }
        }

        if (filters.roomType !== null && filters.roomType.length > 0) {
            stringFilters += '&q.environment.roomTypes.in=';
            for (i = 0; i < filters.roomType.length; i++) {
                if (i > 0) {
                    stringFilters += ',';
                }
                stringFilters += filters.roomType[i]._id;
            }
        }

        if (Array.isArray(filters.name)) {
            if (filters.name.length > 0) {
                if (FilterGroup.smartSearch()) {
                    stringFilters += '&filter=' + filters.name.join(',');
                }
                else {
                    if (filters.sort && (filters.sort.price > 0 || filters.sort.width > 0)) {
                        stringFilters += '&q.labels.lk=' + filters.name.join(',');
                    }
                    else {
                        stringFilters += '&text=' + filters.name.join(',');
                    }
                }
            }
        }

        else if (filters.name) {
            if (FilterGroup.smartSearch()) {
                stringFilters += '&filter=' + filters.name;
            }
            else {
                if (filters.sort && (filters.sort.price > 0 || filters.sort.width > 0)) {
                    stringFilters += '&q.labels.lk=' + filters.name;
                }
                else {
                    stringFilters += '&text=' + filters.name;
                }
            }
        }

        let result = FilterGroup.initSortArray();
        stringFilters += result.stringFilter;
        let sort: any[] = result.sort;

        if (sort.length > 0) {
            stringFilters += '&sort=' + sort.join(',');
        }

        // We only want non kitchen fab objects
        if (!FiltersWidget.getDecorationService().displayGroups) {
            stringFilters += '&q.pipeline.modelState.eq=validated';
            stringFilters += '&q.pipeline.unrealState.eq=ready';
        }

        if (FilterGroup.filters.assets && FilterGroup.filters.assets.length > 0) {
            stringFilters += '&q._id.in=' + FilterGroup.filters.assets;
        }
        return stringFilters;
    };


    static newPinboard() {
        Savane.eventsManager.instance.dispatch(Savane.Events.NEW_PINBOARD);
    };

    static selectPinboard(item) {
        FilterGroup.selectedPinboardId = item._id;
        FilterGroup.filters.assets = item.items;
        FilterGroup.updateFilters(FilterGroup.filters);
    };

    static editPinboard(item) {
        Savane.eventsManager.instance.dispatch(Savane.Events.EDIT_PINBOARD, { pinboard: item });
    };

    static deletePinboard(item) {
        bootbox.dialog({
            className: "confirm",
            message: "Êtes-vous sûr de vouloir supprimer ce pinboard ?",
            buttons: {
                success: {
                    label: 'Oui',
                    className: "btn btn-link ",
                    callback: function () {
                        AssetManagerServices.deletePinboard(item._id, function (result) {
                            if (result) {
                                toastr.success('Pinboard supprimé avec succès.');
                                Savane.eventsManager.instance.dispatch(Savane.Events.REFRESH_PINBOARDS);
                            } else {
                                toastr.error('Une erreur est survenue lors de la suppression du pinboard.');
                            }
                            setTimeout(function () {
                                FilterGroup.$rootScope.$broadcast("cocos-plan-resize-needed", false);
                                Savane.eventsManager.instance.dispatch(Savane.Events.CAMERA_RESIZED);
                            });
                        });
                    }
                },
                danger: {
                    label: 'Non',
                    className: "btn btn-link btn-yes",
                    callback: function () { }
                }
            }
        });
    }

    html(): void {
        this.isDestroyed = false;
        FilterGroup.changePinboardsPage(FilterGroup.currentPage).then(() => {
            let html = this.filtersHtml() + `
            <div>
                ${!FiltersWidget.user.mail ? `
                <div>
                    Favoris non disponible en dehors de HomePlanner
                </div>
                `: ''}

                ${FiltersWidget.user.mail ? `
                <div style="min-height: 200px;">
                    <div style="text-align: right; margin-right: 10px;">
                        <button id="newPinBoard" class="btn btn-success">Nouveau pinboard</button>
                    </div>
                    <form id="publicPinboardsForm">
                        <input id="inputPrivate" class="btn-default" type="radio" name="public_pinboards"> Mes favoris
                        <input id="inputPublic" class="btn-default" type="radio" name="public_pinboards"> Favoris public
                    </form>
                    ${FilterGroup.pinboards.length > 0 ? this.getPinBoardsTableHtml() : ''}
                </div>
                ` : ''}
            </div>
            `;

            setTimeout(() => {
                let val = FilterGroup.filters.public_pinboards ? true : false;
                $('#inputPublic').prop('checked', val);
                $('#inputPrivate').prop('checked', !val);

                this.controller.addEventListener('click', () => {
                    PinBoardsFilterWidget.newPinboard();
                }, 'newPinBoard');

                this.controller.addEventListener('change', () => {
                    FilterGroup.filters.public_pinboards = $('#inputPublic').is(':checked');
                    FilterGroup.getUpdateFunctions(this.filtersFunction)(FilterGroup.filters).then(() => {
                        this.destroy();
                        this.html();
                    });
                }, 'inputPublic');

                this.controller.addEventListener('change', () => {
                    FilterGroup.filters.public_pinboards = $('#inputPublic').is(':checked');
                    FilterGroup.getUpdateFunctions(this.filtersFunction)(FilterGroup.filters).then(() => {
                        this.destroy();
                        this.html();
                    });
                }, 'inputPrivate');
            }, 50);
            let container = document.getElementById(this.container);
            if (!container) {
                return;
            }
            container.innerHTML = html;
        });
    }

    getPinboardsHtml(): string {
        if (!FilterGroup.pinboards || FilterGroup.pinboards.length === 0) {
            return '';
        }
        return FilterGroup.pinboards.map((item) => {
            setTimeout(() => {
                this.controller.addEventListener('click', () => {
                    PinBoardsFilterWidget.selectPinboard(item);
                    this.updatePinboardsTable();
                }, `pinboard-${item._id}`);

                this.controller.addEventListener('click', () => {
                    PinBoardsFilterWidget.editPinboard(item);
                }, `pinboard-${item._id}-edit`);

                this.controller.addEventListener('click', () => {
                    PinBoardsFilterWidget.deletePinboard(item);
                }, `pinboard-${item._id}-delete`);
            }, 50);
            return `
                <tr style="cursor: pointer;">
                    <td style="${FilterGroup.isPinboardSelected(item)}" class="select-pinboard" id="pinboard-${item._id}">${item.name}</td>
                    ${FilterGroup.filters.public_pinboards === false ? `
                        <td>
                            <i style="cursor: pointer;" id="pinboard-${item._id}-edit" class="fas fa-lg fa-edit"></i>
                            <i style="cursor: pointer;" id="pinboard-${item._id}-delete" class="far fa-lg fa-trash-alt"></i>
                        </td>
                    ` : ''}
                </tr>
            `;
        }).join('');
    }

    updatePinboardsTable(): void {
        const tbody = document.getElementById('pinboards-tbody');
        if (tbody) {
            $(".select-pinboard").each((_idx, item) => {
                this.controller.removeEventListener('click', `${item.id}`);
                this.controller.removeEventListener('click', `${item.id}-edit`);
                this.controller.removeEventListener('click', `${item.id}-delete`);
            });
            if (!FilterGroup.pinboards || FilterGroup.pinboards.length === 0) {
                $('#pinboards-table').remove();
                return;
            }
            tbody.innerHTML = this.getPinboardsHtml();
        } else {
            this.html();
        }
    }

    getPinBoardsTableHtml(): string {
        return `
        <div id="pinboards-table" style="margin-bottom:10px; margin-top: 10px; padding:0;width:100%; border-top: #737373 solid 1px;">
            <div>
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="text-align: center;">Résultats</th>
                        </tr>
                    </thead>
                    <tbody id="pinboards-tbody">
                        ${this.getPinboardsHtml()}
                    </tbody>
                </table>
            </div>
            ${this.getPinBoardsPaginationHtml()}
        </div>
        `;
    }

    getPinBoardsPaginationHtml(): string {
        setTimeout(() => {
            this.controller.addEventListeners('click', (e) => {
                e.preventDefault();
                const element = e.target as HTMLElement;
                const page = parseInt(element.getAttribute('data-page')!);
                if (!isNaN(page) && page !== FilterGroup.pagination.currentPage && !element.classList.contains('disabled')) {
                    FilterGroup.changePinboardsPage(page).then(() => {
                        this.controller.removeEventListeners('click', 'pagination-number');
                        this.controller.removeEventListener('click', 'previous');
                        this.controller.removeEventListener('click', 'next');
                        this.getPinBoardsTableHtml();
                    });
                }
            }, 'pagination-number');

            this.controller.addEventListener('click', (e) => {
                e.preventDefault();
                if (FilterGroup.pagination.currentPage > 1) {
                    FilterGroup.changePinboardsPage(FilterGroup.pagination.currentPage - 1).then(() => {
                        this.controller.removeEventListeners('click', 'pagination-number');
                        this.controller.removeEventListener('click', 'previous');
                        this.controller.removeEventListener('click', 'next');
                        this.getPinBoardsTableHtml();
                    });
                }
            }, 'previous');

            this.controller.addEventListener('click', (e) => {
                e.preventDefault();
                if (FilterGroup.pagination.currentPage < FilterGroup.pagination.nbPages) {
                    FilterGroup.changePinboardsPage(FilterGroup.pagination.currentPage + 1).then(() => {
                        this.controller.removeEventListeners('click', 'pagination-number');
                        this.controller.removeEventListener('click', 'previous');
                        this.controller.removeEventListener('click', 'next');
                        this.getPinBoardsTableHtml();
                    });
                }
            }, 'next');
        }, 50);
        return `
        <!-- PAGINATION -->
        <div id="pagination-container" style="background:none;height:24px;background-color : #efefef">
            <ul class="designer-filters pagination">
                <li class="${FilterGroup.pagination.currentPage === 1 ? 'disabled' : ''}">
                    <a id="previous" aria-label="Previous">
                        <span aria-hidden="true">&laquo;</span>
                    </a>
                </li>
                
                ${FilterGroup.pagination.currentPage > 1 ? `
                <li>
                    <a class="pagination-number" data-page="1">${FilterGroup.pagination.list[0].index}</a>
                </li>
                ` : ''}
                
                ${FilterGroup.pagination.currentPage > 2 ? `
                <li>
                    <a class="pagination-number" data-page="2">${FilterGroup.pagination.list[1].index}</a>
                </li>
                ` : ''}

                ${FilterGroup.pagination.currentPage > 5 ? `
                <li>
                    <span>...</span>
                </li>
                ` : ''}

                ${FilterGroup.pagination.currentPage > 4 ? `
                <li>
                    <a class="pagination-number" data-page="${FilterGroup.currentPage - 2}">${FilterGroup.pagination.currentPage - 2}</a>
                </li>
                ` : ''}

                ${FilterGroup.pagination.currentPage > 3 ? `
                <li>
                    <a class="pagination-number" data-page="${FilterGroup.currentPage - 1}">${FilterGroup.pagination.currentPage - 1}</a>
                </li>
                ` : ''}

                <li class="active">
                    <span>${FilterGroup.pagination.currentPage}</span>
                </li>

                ${FilterGroup.pagination.currentPage < FilterGroup.pagination.list.length - 2 ? `
                <li>
                    <a class="pagination-number" data-page="${FilterGroup.currentPage + 1}">${FilterGroup.pagination.currentPage + 1}</a>
                </li>
                ` : ''}

                ${FilterGroup.pagination.currentPage < FilterGroup.pagination.list.length - 3 ? `
                <li>
                    <a class="pagination-number" data-page="${FilterGroup.currentPage + 2}">${FilterGroup.pagination.currentPage + 2}</a>
                </li>
                ` : ''}

                ${FilterGroup.pagination.currentPage < FilterGroup.pagination.list.length - 4 ? `
                <li>
                    <span>...</span>
                </li>
                ` : ''}

                ${FilterGroup.pagination.currentPage < FilterGroup.pagination.list.length - 1 ? `
                <li>
                    <a class="pagination-number" data-page="${FilterGroup.pagination.list.length - 1}">
                        ${FilterGroup.pagination.list.length - 1}
                    </a>
                </li>
                ` : ''}

                ${FilterGroup.pagination.currentPage < FilterGroup.pagination.list.length ? `
                <li>
                    <a class="pagination-number" data-page="${FilterGroup.pagination.list.length}">
                        ${FilterGroup.pagination.list.length}
                    </a>
                </li>
                ` : ''}
                            
                <li class="${FilterGroup.pagination.currentPage === FilterGroup.pagination.nbPages ? 'disabled' : ''}">
                    <a id="next" aria-label="Next">
                        <span aria-hidden="true">&raquo;</span>
                    </a>
                </li>
            </ul>
        </div>
        `;
    }

    destroy(): void {
        super.destroy();
    }
}